import DialogAssistantGenerateRoutesActionMenu from './ActionMenu';
import DialogAssistantGenerateRoutesDialogComponents from './Dialog';

const DialogAssistantGenerateRoutesComponents = {
  ActionMenu: DialogAssistantGenerateRoutesActionMenu,
  Dialog: DialogAssistantGenerateRoutesDialogComponents,
};

export default DialogAssistantGenerateRoutesComponents;
